module.exports = __webpack_public_path__ + "static/publicArt-25_3-1c81cf50d305955b83e58295afe86fbd.jpg";